/*
Copyright (c) 2021.
*/

import maverickPortalhttp from '../../webService/webService';
import maverickPortalApiEndPoint from '../../../config/apiEndPoint';


const  GetSummaryData =  (data) => {

  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.getAnalysisSummary.url + '/'+ data.project_ID + '/' + data.question_ID,
        maverickPortalApiEndPoint.getAnalysisSummary.methodType,
        data
      )
      .then(response => {        
        const res = response.data;
        resolve({ res });
      });
  });
};


const  EditSummaryData =  (data) => {

  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.editSummary.url,
        maverickPortalApiEndPoint.editSummary.methodType,
        data
      )
      .then(response => {        
        const res = response.data;
        resolve({ res });
      });
  });
};


export { GetSummaryData, EditSummaryData};
// export { GetSummaryData};